import React from 'react';
import { Question, QuestionType } from 'services/campaign/types';
import { QuestionExpectedAnswer } from 'generated-graphql/types';
import { KnockOutQuestionView } from './KnockOutQuestionView';
import { QualifyingQuestionView } from './QualifyingQuestionView';
import { DocumentQuestionView } from './DocumentQuestionView';

type CampaignQuestionViewProps = {
  question: Question;
};

export const CampaignQuestionView: React.FC<CampaignQuestionViewProps> = ({
  question
}) => {
  const {
    questionType,
    isMandatory,
    content,
    documentTypes = [],
    expectedAnswer,
    preferredAnswerText,
    preferredAnswerRequirements
  } = question;

  if (questionType === QuestionType.DOCUMENT) {
    return (
      <DocumentQuestionView
        documentTypes={documentTypes}
        isMandatory={isMandatory}
      />
    );
  } else if (isMandatory) {
    return (
      <KnockOutQuestionView
        content={content}
        expectedAnswer={(expectedAnswer as QuestionExpectedAnswer) || null}
      />
    );
  } else {
    return (
      <QualifyingQuestionView
        content={content}
        preferredAnswerText={preferredAnswerText}
        preferredAnswerRequirements={preferredAnswerRequirements}
      />
    );
  }
};
